<script setup lang="ts">
interface Props {
  homeName: string
  awayName: string
}

defineProps<Props>()
</script>

<template>
  <div class="inline-flex h-4 text-sm font-bold">
    <span class="truncate">
      {{ homeName }}
    </span>
    <span class="mx-1">-</span>
    <span class="truncate">
      {{ awayName }}
    </span>
  </div>
</template>
